/**
 * Krafty — product card "add to cart" success animation.
 *
 * Listens for the theme's existing cartUpdate pub/sub event (fired by
 * assets/product-form.js right after a successful add-to-cart) and toggles
 * an `.is-added` class on the triggering card__cart-btn for a short window.
 * component-card.css cross-fades the bag icon into a checkmark while that
 * class is present.
 *
 * Intentionally does NOT modify assets/product-form.js — hooks into the
 * pub/sub system it already publishes to, and locates the button that
 * triggered the add via DOM state instead.
 */
(function () {
  if (window.__cardCartSuccessInit) return;
  window.__cardCartSuccessInit = true;

  function playSuccess(button) {
    if (!button || !button.classList || !button.classList.contains('card__cart-btn')) return;
    button.classList.add('is-added');
    window.clearTimeout(button.__cartSuccessTimeout);
    button.__cartSuccessTimeout = window.setTimeout(function () {
      button.classList.remove('is-added');
    }, 1600);
  }

  function findTriggerButton() {
    // Single-variant path: product-form.js's onSubmitHandler adds .loading
    // to the button synchronously on submit and only removes it in a
    // .finally() that runs AFTER the cartUpdate event has already published,
    // so at the moment our subscriber runs, the button is still marked.
    var loadingButton = document.querySelector('.card__cart-btn.loading');
    if (loadingButton) return loadingButton;

    // Multi-variant path: the quick-add-modal that just submitted still has
    // its openedBy reference pointing at the card button that opened it.
    var openModal = document.querySelector('quick-add-modal[open], .quick-add-modal[open]');
    if (openModal && openModal.openedBy && openModal.openedBy.classList.contains('card__cart-btn')) {
      return openModal.openedBy;
    }

    return null;
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      if (!event || event.source !== 'product-form') return;
      playSuccess(findTriggerButton());
    });
  }
})();
